import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fillOpacity: '0.87',
  },
});

const TraysIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon} fill="white">
      <path d="M16.7744 0L15.6032 3.6032H8.4032L7.2256 0H0V10.8032H24V0H16.7744Z" />
      <path d="M16.7744 13.2032L15.6032 16.8H8.4032L7.2256 13.2032H0V24H24V13.2032H16.7744Z" />
    </SvgIcon>
  );
};

export default memo(TraysIcon);
